import { graphql } from '@/gql'

export const FieldableFormCustomFieldValueFragment = graphql(/* GraphQL */ `
  fragment FieldableFormCustomFieldValue on CustomFieldValue {
    id
    content
    displayValue
    customField {
      id
      fieldType
    }
    customFieldOption {
      id
      value
    }
    file {
      id
      name
      humanReadableSize
      url
    }
  }
`)

export const FieldableFormCustomFieldFragment = graphql(/* GraphQL */ `
  fragment FieldableFormCustomField on CustomField {
    id
    account {
      id
      name
    }
    title
    description
    fieldType
    appliesTo
    apiOnly
    workerInputAllowed
    recruiterInputAllowed
    sharedWithClients
    sharedWithStaffingAgencies
    viewerOwnsField
    settings {
      validation
    }
    customFieldOptions {
      id
      value
      displayOrder
    }
    viewerCanManageFieldValues(account: $viewerAccount)
  }
`)

export const CUSTOM_FIELD_VALUES_VIEW_FRAGMENT = graphql(/* GraphQL */ `
  fragment CustomFieldValuesView on CustomFieldValue {
    id
    displayValue
    customField {
      id
      title
      description
      visibility
      fieldType
      appliesTo
      archivedAt
      account {
        id
        name
      }
      workerInputAllowed
      recruiterInputAllowed
      sharedWithClients
      sharedWithStaffingAgencies
      viewerOwnsField
    }
    file {
      id
      name
      url
    }
  }
`)
